<template>
    <div v-if="loaded" class="container white-page-container d-flex align-items-center justify-content-center">
        <div v-if="!noAnswer && cadhAnswerId">
            <div class="text-center mt-6">
                <img class="ot-logo" :src="otLogo" alt="logo de l'office de tourisme">
            </div>

            <div class="mt-4 main-content"
                 style="margin-bottom: 30px"
                 v-html="thanksText"
                 v-if="thanksText !== null"></div>
        </div>

        <div v-if="noAnswer">
            <h4 class="text-center mt-6 information-text">Merci pour votre règlement.</h4>
        </div>
    </div>
</template>

<script>
export default {
    name: "PayfipRedirectionAfterPayment",
    data() {
        return {
            cadhAnswerId: null,
            code: null,
            success: false,
            loaded: true,
            noAnswer: false,
            otLogo: null,
            thanksText: null,
        }
    },
    methods: {
        getCadhConfigThanks() {
            let payload = {
                cadhAnswerId: this.cadhAnswerId,
                urlCl: process.env.VUE_APP_PAYFIP_URLCL
            }

            this.$http.post("", payload).then((response) => {
                if(response.body.success) {
                    this.otLogo = response.body.data.logo
                    this.thanksText = response.body.data.thanksText
                    this.loaded = true
                } else {
                    this.noAnswer = true
                }
            })
        }
    },
    created() {
        window.Intercom("shutdown")
        window.Intercom("hide")

        if(this.$route.params.cadhAnswerId){
            this.cadhAnswerId = atob(this.$route.params.cadhAnswerId)
            this.getCadhConfigThanks()
        } else {
            this.noAnswer = true
        }
    },
}
</script>